<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div class="pt-6" :style="store.getters.getConfig.is_header
            ? 'min-height: calc(100vh - 135px)'
            : 'min-height: calc(100vh - 115px)'">
          <Menu :selectedKeys="[1]"></Menu>
        </div>
      </div>
      <div class="float-right p-6" style="width: calc(100% - 128px)">
        <a-spin :spinning="spinning">
          <div class="pb-6 overflow-hidden">
            <div class="float-left overflow-hidden">
              <span class="float-left pr-2 leading-8">搜索:</span>
              <a-textarea
                class="float-left"
                style="width: 200px"
                autoSize
                v-model="queryParam.custom.search"
                placeholder="请输入要搜索的内容"
                @pressEnter="press_enter"
              ></a-textarea>
            </div>
            <div class="float-left pl-6">
              <a-button type="primary" class="mr-2" @click="gets(1)"
                >搜索</a-button
              >
              <a-button type="default" @click="reset">重置</a-button>
            </div>
            <div class="float-right">
              <a-button type="primary" @click="exportExcelFlag = true"
                >导出报表</a-button
              >
            </div>
          </div>
          <a-table
            :loading="loading"
            :columns="columns"
            :data-source="list"
            :pagination="pagination"
            bordered
            row-key="id"
            size="small"
          >
          </a-table>
        </a-spin>
      </div>
    </div>
    <ExportForm
      :visible="exportExcelFlag"
      @ok="exportExcel"
      @cancel="exportExcelFlag = false"
    ></ExportForm>
  </div>
</template>
<script>
import { columns } from './_list';
import { my_teams, team_export } from '@/api/user';
import { downloadUrl } from '@/utils/download';
import Menu from '@/views/admin/menu/index.vue';
import ExportForm from './module/exportForm.vue';
import store from '@/store/index';
export default {
  components: {
    Menu,
    ExportForm,
  },
  data() {
    return {
      queryParam: { custom: { search: '' } },
      columns,
      pagination: {
        current: 1,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page;
          this.gets();
        },
      },
      loading: true,
      exportExcelFlag: false,
      list: [],
      spinning: false,
      store: store,
    };
  },
  activated() {
    this.gets(1);
  },
  methods: {
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      let res = await my_teams({
        current: this.pagination.current,
        qp: JSON.stringify(this.queryParam),
      });
      this.list = res.data || [];
      this.$set(this.pagination, 'total', res.total);
      this.loading = false;
    },
    async exportExcel(e) {
      this.spinning = true;
      const res = await team_export({ start: e[0], end: e[1] });
      await downloadUrl(this.$ossUrl + '/' + res, e[0] + '~' + e[1] + '.xlsx');
      this.spinning = false;
    },
    press_enter(e) {
      e.preventDefault();
      this.gets(1);
    },
    reset() {
      this.queryParam = { custom: { search: '' }, time: {} };
      this.gets(1);
    },
  },
};
</script>
